var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.99,
    y: 24.71,
    className: "st0",
    width: 2.61,
    height: 20.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.6,45.88H1.99c-0.27,0-0.49-0.22-0.49-0.49V24.71c0-0.27,0.22-0.49,0.49-0.49H4.6 c0.27,0,0.49,0.22,0.49,0.49v20.68C5.09,45.66,4.87,45.88,4.6,45.88z M2.48,44.9h1.63V25.2H2.48V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 24.71,
    className: "st0",
    width: 13.18,
    height: 20.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.79,45.88H4.6c-0.27,0-0.49-0.22-0.49-0.49V24.71c0-0.27,0.22-0.49,0.49-0.49h13.18 c0.27,0,0.49,0.22,0.49,0.49v20.68C18.28,45.66,18.06,45.88,17.79,45.88z M5.09,44.9h12.2V25.2H5.09V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 4.6,
    y: 36.04,
    className: "st1",
    width: 13.18,
    height: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.79,39.54H4.6c-0.27,0-0.49-0.22-0.49-0.49v-3.01c0-0.27,0.22-0.49,0.49-0.49h13.18 c0.27,0,0.49,0.22,0.49,0.49v3.01C18.28,39.32,18.06,39.54,17.79,39.54z M5.09,38.56h12.2v-2.03H5.09V38.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.99,
    y: 39.05,
    className: "st0",
    width: 6.4,
    height: 6.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.39,45.88h-6.4c-0.27,0-0.49-0.22-0.49-0.49v-6.34c0-0.27,0.22-0.49,0.49-0.49h6.4 c0.27,0,0.49,0.22,0.49,0.49v6.34C14.88,45.66,14.67,45.88,14.39,45.88z M8.49,44.9h5.42v-5.36H8.49V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.79,
    y: 24.71,
    className: "st0",
    width: 2.62,
    height: 20.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.41,45.88h-2.62c-0.27,0-0.49-0.22-0.49-0.49V24.71c0-0.27,0.22-0.49,0.49-0.49h2.62 c0.27,0,0.49,0.22,0.49,0.49v20.68C20.9,45.66,20.68,45.88,20.41,45.88z M18.28,44.9h1.64V25.2h-1.64V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.19,45.88c-0.27,0-0.49-0.22-0.49-0.49v-6.34c0-0.27,0.22-0.49,0.49-0.49s0.49,0.22,0.49,0.49v6.34 C11.68,45.66,11.47,45.88,11.19,45.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.51,46.37v1.29c0,0.54-0.44,0.98-0.98,0.98H1.47c-0.54,0-0.98-0.44-0.98-0.98v-1.29 c0-0.54,0.44-0.98,0.98-0.98h47.06C49.07,45.39,49.51,45.82,49.51,46.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.53,49.13H1.47C0.66,49.13,0,48.47,0,47.66v-1.29c0-0.81,0.66-1.47,1.47-1.47h47.06 c0.81,0,1.47,0.66,1.47,1.47v1.29C50,48.47,49.34,49.13,48.53,49.13z M1.47,45.88c-0.27,0-0.49,0.22-0.49,0.49v1.29 c0,0.27,0.22,0.49,0.49,0.49h47.06c0.27,0,0.49-0.22,0.49-0.49v-1.29c0-0.27-0.22-0.49-0.49-0.49H1.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.51,21.27v2.46c0,0.54-0.44,0.98-0.98,0.98H1.47c-0.54,0-0.98-0.44-0.98-0.98v-2.46 c0-0.54,0.44-0.98,0.98-0.98h47.06C49.07,20.29,49.51,20.73,49.51,21.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.53,25.2H1.47C0.66,25.2,0,24.54,0,23.73v-2.46c0-0.81,0.66-1.47,1.47-1.47h47.06 c0.81,0,1.47,0.66,1.47,1.47v2.46C50,24.54,49.34,25.2,48.53,25.2z M1.47,20.78c-0.27,0-0.49,0.22-0.49,0.49v2.46 c0,0.27,0.22,0.49,0.49,0.49h47.06c0.27,0,0.49-0.22,0.49-0.49v-2.46c0-0.27-0.22-0.49-0.49-0.49H1.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.47,18.74v1.54H2.52v-1.54c0-0.41,0.26-0.78,0.65-0.92l14.85-5.38h13.95l14.85,5.38 C47.21,17.96,47.47,18.33,47.47,18.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.47,20.77H2.52c-0.27,0-0.49-0.22-0.49-0.49v-1.54c0-0.62,0.39-1.17,0.97-1.38l14.85-5.38 c0.05-0.02,0.11-0.03,0.17-0.03h13.95c0.06,0,0.11,0.01,0.17,0.03l14.85,5.38c0.58,0.21,0.97,0.76,0.97,1.38v1.54 C47.96,20.55,47.74,20.77,47.47,20.77z M3.01,19.79h43.97v-1.05c0-0.21-0.13-0.39-0.32-0.46l-14.77-5.35H18.11L3.33,18.28 c-0.19,0.07-0.32,0.25-0.32,0.46V19.79z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.39,
    y: 24.71,
    className: "st0",
    width: 2.61,
    height: 20.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,45.88h-2.61c-0.27,0-0.49-0.22-0.49-0.49V24.71c0-0.27,0.22-0.49,0.49-0.49H48 c0.27,0,0.49,0.22,0.49,0.49v20.68C48.49,45.66,48.27,45.88,48,45.88z M45.88,44.9h1.63V25.2h-1.63V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.2,
    y: 24.71,
    className: "st0",
    width: 13.18,
    height: 20.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.39,45.88H32.2c-0.27,0-0.49-0.22-0.49-0.49V24.71c0-0.27,0.22-0.49,0.49-0.49h13.18 c0.27,0,0.49,0.22,0.49,0.49v20.68C45.88,45.66,45.66,45.88,45.39,45.88z M32.69,44.9h12.2V25.2h-12.2V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.2,
    y: 36.04,
    className: "st1",
    width: 13.18,
    height: 3.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.39,39.54H32.2c-0.27,0-0.49-0.22-0.49-0.49v-3.01c0-0.27,0.22-0.49,0.49-0.49h13.18 c0.27,0,0.49,0.22,0.49,0.49v3.01C45.88,39.32,45.66,39.54,45.39,39.54z M32.69,38.56h12.2v-2.03h-12.2V38.56z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.6,
    y: 39.05,
    className: "st0",
    width: 6.4,
    height: 6.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42,45.88h-6.4c-0.27,0-0.49-0.22-0.49-0.49v-6.34c0-0.27,0.22-0.49,0.49-0.49H42c0.27,0,0.49,0.22,0.49,0.49 v6.34C42.49,45.66,42.27,45.88,42,45.88z M36.09,44.9h5.42v-5.36h-5.42V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.58,
    y: 24.71,
    className: "st0",
    width: 2.62,
    height: 20.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2,45.88h-2.62c-0.27,0-0.49-0.22-0.49-0.49V24.71c0-0.27,0.22-0.49,0.49-0.49h2.62 c0.27,0,0.49,0.22,0.49,0.49v20.68C32.69,45.66,32.48,45.88,32.2,45.88z M30.07,44.9h1.64V25.2h-1.64V44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 38.8,
    y1: 45.39,
    x2: 38.8,
    y2: 39.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.8,45.88c-0.27,0-0.49-0.22-0.49-0.49v-6.34c0-0.27,0.22-0.49,0.49-0.49c0.27,0,0.49,0.22,0.49,0.49v6.34 C39.29,45.66,39.07,45.88,38.8,45.88z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18.02,
    y: 9.41,
    className: "st0",
    width: 13.95,
    height: 3.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.97,12.92H18.02c-0.27,0-0.49-0.22-0.49-0.49V9.41c0-0.27,0.22-0.49,0.49-0.49h13.95 c0.27,0,0.49,0.22,0.49,0.49v3.03C32.46,12.71,32.24,12.92,31.97,12.92z M18.51,11.94h12.97V9.9H18.51V11.94z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "33.32,7.75 33.32,9.41 16.67,9.41 16.67,7.75 24.98,1.38 24.98,1.36 25,1.37 25.01,1.36 25.01,1.38  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.32,9.9H16.67c-0.27,0-0.49-0.22-0.49-0.49V7.75c0-0.15,0.07-0.3,0.19-0.39l8.25-6.33 c0.03-0.03,0.06-0.06,0.1-0.08c0.1-0.07,0.23-0.09,0.35-0.07c0.04,0,0.09,0.02,0.13,0.03c0.07,0.03,0.14,0.08,0.19,0.13l8.24,6.32 c0.12,0.09,0.19,0.24,0.19,0.39v1.66C33.81,9.68,33.59,9.9,33.32,9.9z M17.16,8.92h15.68V7.99l-7.84-6.01l-7.84,6.01V8.92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecking);
export default __webpack_public_path__ + "static/media/decking.700e9023aea3c105cca95e8e013d4902.svg";
export { ForwardRef as ReactComponent };